import Part from "../../part";

export default class Dessert extends Part {
  get options() {
    return {

      'simple': {
        price: 4,
        description: `Classic options such as a selection of cookies and brownies from Zingerman’s Bakehouse.`,
      },
      'medium': {
        price: 8,
        description: `A more diverse selection of desserts, such as gelato from Zingerman’s Creamery with Zingerman’s Bakehouse sheet cakes and lemon tartlets.`,
      },
      'deluxe': {
        price: 13,
        description: `A wide variety to choose from, including fancy miniature desserts (éclairs, Paris-Brest, lemon tartlets, and pecan diamonds), and gelato with fresh berries.`,
      },
      'none': {
        price: 0,
      },
    };
  }

  constructor(section) {
    super(section);
  }

}



// WEBPACK FOOTER //
// ./scripts/catcalc/sections/food/dessert.js